import { useShopI18n } from '../i18n/ShopI18n'
import type { Extra, ShopItem } from '../types'
import { describeShopItem, formatShopAmount, formatShopExtraAmount } from '../utils/shopFormatters'
import { shopArtwork } from './shopArtwork'

function rewardIcon(extra: Extra) {
    const type = `${extra.type} ${extra.goodName}`.toLowerCase()
    if (/shop.?bonus|web.?bonus/.test(type)) return shopArtwork.gift
    if (/league|liga/.test(type)) return shopArtwork.league
    if (/loyal|treue/.test(type)) return shopArtwork.loyalty
    if (/joker/.test(type)) return shopArtwork.joker
    if (/chips/.test(type)) return shopArtwork.coin
    return shopArtwork.trophy
}
export function BalanceRow({ balance }: { balance?: number }) {
    const { t, locale } = useShopI18n()
    return balance !== undefined && Number.isFinite(balance) ? <div className="shop-new-balance"><dt>{t("Neues Guthaben")}</dt><dd>{formatShopAmount(balance, locale)} {t("Chips")}</dd></div> : null
}
export default function RewardReceipt({ item, balance, className = '' }: { item?: ShopItem; balance?: number; className?: string }) {
    const { t, locale } = useShopI18n()
    const product = item ? describeShopItem(item, locale, t) : undefined
    return <dl className={`shop-receipt shop-reward-receipt ${className}`}>
        {product && <div><dt><span className="shop-reward-icon"><img src={item?.type === 'ultimate-pass' ? shopArtwork.ultimate : product.joker ? shopArtwork.joker : shopArtwork.coin} alt="" /></span>{product.title || product.unit}</dt><dd>{product.subscription ? '' : '+'}{product.amount}{product.perDay && <small> · {product.perDay}</small>}</dd></div>}
        {item?.shopBonus && <div><dt><span className="shop-reward-icon"><img src={shopArtwork.gift} alt="" /></span>{item.shopBonus.title}</dt><dd>{formatShopExtraAmount({ amount: item.shopBonus.amount, amountText: '' }, locale)}</dd></div>}
        {item?.extras?.map((extra, index) => <div key={index}><dt><span className="shop-reward-icon"><img src={rewardIcon(extra)} alt="" /></span>{extra.title || extra.goodName}</dt><dd>{formatShopExtraAmount(extra, locale)}</dd></div>)}
        <BalanceRow balance={balance} />
    </dl>
}
